<template>
    <RosterManagement
        :routePlantID="plantID"
        :routeProductCategoryID="productCategoryID">
    </RosterManagement>
</template>

<script>
import RosterManagement from '@/components/berriesRoster/RosterManagement.vue'

export default {
    components: {
        RosterManagement
    },
    data(){
        return {

        };
    },
    computed: {
        plantID() { 
            let val = this.$route.query.plantID;

            if(val) {
                return parseInt(val);
            }
            
            return null;
        },
        productCategoryID() {
            let val = this.$route.query.productCategoryID;

            if(val) {
                return parseInt(val);
            }
            
            return null;
        }
    },
    methods: {

    },
    created(){
        
    }
}
</script>